<template>
  <el-menu
    class="menu-nav"
    router
    :default-active="currentPath"
    background-color="#20222a"
    text-color="rgba(255,255,255,.8)"
    active-text-color="#ffd04b"
    :collapse="isCollapse">
   <el-submenu index="5">
     <template slot="title">
       <i class="el-icon-news"></i>
       <span>我的竞价</span>
     </template>
     <el-menu-item index="/enrollProjectAlready">我报名的项目</el-menu-item>

    <el-menu-item index="/biddingProject">我的竞价大厅</el-menu-item>

   <el-menu-item index="/successProjectList">我的中标项目</el-menu-item>

   <el-menu-item index="/redorderRecordList">我的报价记录</el-menu-item>

   </el-submenu>

   <el-submenu index="61">
        <template slot="title">
          <i class="el-icon-reading"></i>
          <span>订单管理</span>
        </template>
   <!--     <el-menu-item index="/userSearch">查询个人信息</el-menu-item>
    -->
       <el-menu-item index="/order-search">查询订单信息</el-menu-item>
      </el-submenu>

   <el-submenu index="6">
     <template slot="title">
       <i class="el-icon-reading"></i>
       <span>个人信息管理</span>
     </template>
<!--     <el-menu-item index="/userSearch">查询个人信息</el-menu-item>
 -->
    <el-menu-item index="/userUpdate">修改登录密码</el-menu-item>
   </el-submenu>
  </el-menu>


</template>

<script>
export default {
  props: ['isCollapse'],
  data () {
    return {
      currentPath: location.pathname
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-menu-item.is-active {
        background-color: #20222a !important;
        color: #fff;
        border-bottom:none !important;
       /* span {
          color: #fff !important;
        } */
      }
  .el-menu {
    border: none;
  }
  .menu-nav:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
</style>
